<template>
  <div class="balloon-container" :class="backgroundColor">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'CustomBalloon',
  meta: {
    description: 'Componente común Balloon contenedor.',
  },
  props: {
    text: {
      type: String,
      required: true,
      default: '',
      meta: {
        description: 'Texto del Ballon',
        example: 'some title',
      },
    },
    backgroundColor: {
      type: String,
      default: '',
      meta: {
        description:
          'Color de fondo del Ballon, Enumeración en import { Colors } from "@/components/common"',
        example: 'Colors.GREEN',
      },
    },
  },
};
</script>

<style scoped>
.balloon-container {
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px 8px 5px 8px;
  background-color: #f4f6f3;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 900;
}
.balloon-container.green {
  background-color: #a4e5b2;
}
.balloon-container.brown {
  background-color: #d5b899;
}
.balloon-container.yellow {
  background-color: #f8ea80;
}
.balloon-container.pink {
  background-color: #fcc9c8;
}
.balloon-container.violet {
  background-color: #ddb3d7;
}
.balloon-container.cream {
  background-color: #f8ca80;
}
.balloon-container.gray {
  background-color: #D9E5DF;
}

.bg-secondary-23 {
  background-color: #fcc9c8;
}
.bg-secondary-23 {
  background-color: #fcc9c8;
}
.bg-primary-15 {
  background-color: #a4e5b2;
}
.bg-primary-11 {
  background-color: #a4e5b2;
}
.bg-yellow-2 {
  background-color: #FAE76F;
}
.bg-secondary-24 {
  background-color: #d5b899;
}
.bg-secondary-25 {
  background-color: #ac99c1;
}
</style>
